module.exports = __webpack_public_path__ + "img/9788983717863.41008b1b.jpg";